import { jsx, jsxs } from "react/jsx-runtime";
import { Badge, Box, Button, Flex, IconButton, Image, Tooltip } from "pcln-design-system";
import { InformationOutline } from "pcln-icons";
import { useContext, useState } from "react";
import styled_components from "styled-components";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { tooltipLogoUrl } from "../../utils/urls.js";
const StyledTooltip = /*#__PURE__*/ styled_components(Tooltip).withConfig({
    displayName: "PennyToolTip__StyledTooltip"
})([
    "left:",
    ";width:",
    ";bottom:",
    ";z-index:",
    ";text-align:left;",
    ""
], (props)=>props.isMobile ? 'auto' : '-8px', (props)=>{
    if (props.styles?.inputGradientFocus && props.isMobile) return '80px';
    return props.isMobile ? '250px' : '300px';
}, (props)=>props.styles?.inputGradientFocus ? '8px' : null, (props)=>props.zIndex ?? '9999', (props)=>props.isMobile && `
    position: absolute;
    right: auto;
    left: 50% !important;
    transform: translateX(-50%);
    max-width: 90vw;
    width: 180px;
  `);
const StyledFlex = /*#__PURE__*/ styled_components(Flex).withConfig({
    displayName: "PennyToolTip__StyledFlex"
})([
    "align-items:center;z-index:",
    ";"
], (props)=>props.tooltipZIndex || '9999');
const PennyToolTip = (props)=>{
    const [isDisplayed, setIsDisplayed] = useState(false);
    const { onClearHistory, tooltipZIndex, styles } = props;
    const { isMobile } = useContext(ChatbotDataContext);
    const TRAVEL_BOT_LOGO = tooltipLogoUrl(styles?.inputGradientFocus ? 'penny_portal_logo_v1.0.svg' : 'pcln_bot_penny_logo_v1.1.svg').href;
    const msgPositionProp = 'top' === props.msgPosition ? {
        top: true
    } : {};
    const IconButtonProps = {
        ml: '4px',
        mt: '2px',
        id: 'openTooltipButton',
        'data-testid': 'openTooltipButton',
        title: 'open tooltip',
        icon: /*#__PURE__*/ jsx(InformationOutline, {
            size: 16
        })
    };
    const badgeProps = styles?.inputGradientFocus ? {
        mt: 1,
        size: 'captionSmall',
        color: 'text.light',
        bg: 'border.tint'
    } : {
        color: 'primary',
        bg: 'background.light'
    };
    return /*#__PURE__*/ jsxs(StyledFlex, {
        tooltipZIndex: tooltipZIndex,
        children: [
            /*#__PURE__*/ jsx(Image, {
                src: TRAVEL_BOT_LOGO,
                height: "28",
                width: "68",
                alt: "Travel Bot Logo",
                mr: 1
            }),
            /*#__PURE__*/ jsx(Badge, {
                ...badgeProps,
                children: "BETA"
            }),
            onClearHistory && /*#__PURE__*/ jsx(Button, {
                ml: "2",
                size: "small",
                variation: "plain",
                onClick: onClearHistory,
                children: "Clear"
            }),
            /*#__PURE__*/ jsxs(Box, {
                mr: "0",
                children: [
                    /*#__PURE__*/ jsx(IconButton, {
                        ...IconButtonProps,
                        onClick: ()=>setIsDisplayed(!isDisplayed)
                    }),
                    isDisplayed && /*#__PURE__*/ jsxs(StyledTooltip, {
                        ...msgPositionProp,
                        zIndex: tooltipZIndex,
                        styles: styles,
                        bg: "background.darkest",
                        color: "background.lightest",
                        center: isMobile,
                        left: !isMobile,
                        isMobile: isMobile,
                        children: [
                            "Powered by OpenAI. Chat transcripts are recorded for quality review purposes. Penny can make mistakes. Please do not share any personal information in the chat.",
                            /*#__PURE__*/ jsx("br", {}),
                            /*#__PURE__*/ jsx("br", {}),
                            "\xa9 ",
                            new Date().getFullYear(),
                            " Priceline - Patent Pending"
                        ]
                    })
                ]
            })
        ]
    });
};
const Header_PennyToolTip = PennyToolTip;
export { Header_PennyToolTip as default };
